import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: 'app-secure-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.scss'],
})
export class OrganizationListComponent implements  OnInit, AfterViewInit  {

  page: Page<OrganizationResponseModel>;
  dataSource: MatTableDataSource<OrganizationResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  displayedColumns: string[] = [
    "id",
    "orgLogo",
    "orgCode",
    "orgName",
    // "action"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
    ) {}

  ngOnInit(): void {
  
  }

  ngAfterViewInit() {
    this.loadData(); 
  }

  loadData() {
    this.isLoading = true;
    this.masterService.getOrgList().subscribe((page: any)=>{
      this.isLoading = false;
      console.log(page.content);
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
    });
  }
  
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  editOrganization(organizationKey: number) {
    console.log("Edit Organization called ******** key for org edit"+organizationKey);
    this.router.navigate(['/secure', 'master', 'organization', 'au', organizationKey]);
  }

  deactivate(key: number) {
   if(confirm("Do you want to De-Activate the Organization")) {
    console.log("Key for deactivate "+key);
    this.masterService.deactivareOrg(key, 'N').subscribe((data: any)=>{
      if(data.status === 'SUCCESS') {
        let selectedObj = this.page.content.find(o => o.key === key);
        selectedObj.activeFlag = 'N';
      }
      else {
        this.errorToast(data.errorMessage);
      }
    });
   } 
  }

  activate(key: number) {
    if(confirm("Do you want to Activate the Organization")) {
      console.log("Key for activate "+key);
      this.masterService.deactivareOrg(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
